import { withWidth } from '@material-ui/core';
import { Container, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
    textAlign: 'center',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
  glow: {
    textShadow: '0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12',
  },
}));

const Copy1C = ({props}) => {
  const classes = useStyles();

  const [marginsA, setmarginsA] = useState(0);

  useEffect(() => {
    const Copy1CaElement = document.getElementById('Copy1CA');
    const calculatedMarginA = (window.innerHeight - Copy1CaElement.clientHeight) / 2;
    setmarginsA(
      calculatedMarginA > window.innerHeight / 4 ? calculatedMarginA : window.innerHeight / 4,
    );
  }, []);

  return (
    <Container>
      <div id="Copy1CA" style={{ margin: `${marginsA}px auto` }}>
        <Typography className={classes.textMonarcha} sx={{ color: '#ffbf12' }} variant="h3">
          <span style={{ color: '#fff' }}> Your </span>personal brand <br />
          <span style={{ color: '#fff' }}>Becomes</span> a startup company
          <br />
          <br />
          <span style={{ color: '#fff' }}>
            - with stocks holding <br />
            and growing its value over time
          </span>
          <br />
          <br />
          To secure your <br />
          financial future.
        </Typography>
      </div>
    </Container>
  );
};
export default withWidth()(Copy1C);
